(function () {
  var SHOP_DOMAIN = '627314-66.myshopify.com';
  var JM_TOKEN = 'O0yVxB2LInOh756s-pxL3FsnTF8';
  var PER_PAGE = 5;

  var STAR_SVG = '<svg viewBox="0 0 24 24"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/></svg>';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function starsHTML(sectionId, count, size) {
    var out = '';
    for (var i = 0; i < 5; i++) {
      out += '<span class="zingy-star-' + sectionId + (i < count ? ' zingy-star--on-' + sectionId : '') + '" style="width:' + size + 'px;height:' + size + 'px;">' + STAR_SVG + '</span>';
    }
    return out;
  }

  function formatDate(raw) {
    if (!raw) return '';
    var d = new Date(raw.replace(' ', 'T').replace(' UTC', 'Z'));
    if (isNaN(d.getTime())) return '';
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ', ' + d.getFullYear();
  }

  // Previously this moved the form into our narrow review-summary sidebar
  // via a MutationObserver, but that caused two problems: the form looked
  // cramped/distorted once squeezed into that fixed-width column, and on a
  // second click Judge.me would sometimes create a second, fresh instance
  // in its own native spot (since the first had already been moved out of
  // where Judge.me expected to find it) - resulting in two forms on screen.
  // Judge.me's own default rendering (inline, centered, full width) already
  // looks correct on its own, so now we just scroll the person to it
  // instead of moving it anywhere.
  function scrollToReviewFormWhenReady() {
    var attempts = 0;
    var maxAttempts = 20;
    var timer = setInterval(function () {
      attempts++;
      var wrapper = document.querySelector('.jdgm-form-dynamic-wrapper');
      if (wrapper && wrapper.innerHTML.trim() !== '') {
        clearInterval(timer);
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, 150);
  }

  function attachRealWriteReviewButton(sectionId) {
    var wrap = document.querySelector('.zingy-reviews-writeholder-' + sectionId);
    if (!wrap) return;
    var attempts = 0;
    var maxAttempts = 20;
    var timer = setInterval(function () {
      attempts++;
      var realBtn = document.querySelector('.jdgm-rev-widg .jdgm-write-rev-link');
      if (realBtn) {
        clearInterval(timer);
        var proxyBtn = document.createElement('button');
        proxyBtn.type = 'button';
        proxyBtn.textContent = 'Write a review';
        proxyBtn.className = 'zingy-reviews-writebtn-' + sectionId + ' btn';
        proxyBtn.addEventListener('click', function () {
          // If a form is already open somewhere on the page, just scroll to
          // it instead of clicking the real link again - clicking a second
          // time is what caused Judge.me to spawn a duplicate form.
          var existing = document.querySelector('.jdgm-form-dynamic-wrapper');
          if (existing && existing.innerHTML.trim() !== '') {
            existing.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          realBtn.click();
          scrollToReviewFormWhenReady();
        });
        wrap.appendChild(proxyBtn);
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, 300);
  }

  function initReviews(root) {
    var sectionId = root.getAttribute('data-section-id');
    var productHandle = root.getAttribute('data-product-handle');
    var summaryEl = document.getElementById('zingy-reviews-summary-' + sectionId);
    var listEl = document.getElementById('zingy-reviews-list-' + sectionId);
    var paginationEl = document.getElementById('zingy-reviews-pagination-' + sectionId);
    if (!summaryEl || !listEl) return;

    function renderSummary(doc) {
      var avgStarsEl = doc.querySelector('.jdgm-rev-widg__summary-stars');
      var avgLabel = avgStarsEl ? avgStarsEl.getAttribute('aria-label') || '' : '';
      var avgMatch = avgLabel.match(/[\d.]+/);
      var avg = avgMatch ? avgMatch[0] : '0';
      var countTextEl = doc.querySelector('.jdgm-rev-widg__summary-text');
      var countMatch = countTextEl ? (countTextEl.textContent.match(/\d+/) || ['0']) : ['0'];
      var count = countMatch[0];

      var histRows = doc.querySelectorAll('.jdgm-histogram__row[data-rating]');
      var histHTML = '';
      histRows.forEach(function (row) {
        var rating = row.getAttribute('data-rating');
        if (!/^[1-5]$/.test(rating)) return;
        var freq = row.getAttribute('data-frequency') || '0';
        var pct = row.getAttribute('data-percentage') || '0';
        histHTML += '<div class="zingy-hist-row-' + sectionId + '">' +
          '<span class="zingy-hist-label-' + sectionId + '">' + rating + STAR_SVG + '</span>' +
          '<div class="zingy-hist-bar-' + sectionId + '"><div class="zingy-hist-fill-' + sectionId + '" style="width:' + pct + '%;"></div></div>' +
          '<span class="zingy-hist-count-' + sectionId + '">' + freq + '</span>' +
          '</div>';
      });

      summaryEl.innerHTML =
        '<div class="zingy-reviews-avg-' + sectionId + '">' +
        '<p class="zingy-reviews-avgnum-' + sectionId + '">' + avg + '</p>' +
        '<div class="zingy-reviews-avgstars-' + sectionId + '">' + starsHTML(sectionId, Math.round(parseFloat(avg)), 16) + '</div>' +
        '<p class="zingy-reviews-avgcount-' + sectionId + '">' + count + ' reviews</p>' +
        '</div>' +
        '<div class="zingy-reviews-hist-' + sectionId + '">' + histHTML + '</div>' +
        '<div class="zingy-reviews-writeholder-' + sectionId + '"></div>' +
        '<p class="zingy-reviews-verifiednote-' + sectionId + '">Reviews collected &amp; verified by Judge.me</p>';
      attachRealWriteReviewButton(sectionId);
    }

    function renderReviews(doc) {
      var revs = doc.querySelectorAll('.jdgm-rev');
      var html = '';
      revs.forEach(function (rev) {
        var verified = !!rev.querySelector('.jdgm-rev__buyer-badge-wrapper .jdgm-rev__buyer-badge');
        var authorWrap = rev.querySelector('.jdgm-rev__author-wrapper');
        var authorEl = authorWrap ? authorWrap.querySelector('.jdgm-rev__author') : null;
        var author = (authorEl ? authorEl.textContent : 'Anonymous').trim() || 'Anonymous';
        var locationEl = authorWrap ? authorWrap.querySelector('.jdgm-rev__location') : null;
        var location = locationEl ? locationEl.textContent.trim() : '';
        var ratingEl = rev.querySelector('.jdgm-rev__rating');
        var rating = ratingEl ? parseInt(ratingEl.getAttribute('data-score'), 10) : 0;
        var timeEl = rev.querySelector('.jdgm-rev__timestamp');
        var dateText = formatDate(timeEl ? timeEl.getAttribute('data-content') : '');
        var titleEl = rev.querySelector('.jdgm-rev__title');
        var title = titleEl ? titleEl.textContent.trim() : '';
        var bodyEl = rev.querySelector('.jdgm-rev__body');
        var body = bodyEl ? bodyEl.textContent.trim() : '';
        var pics = rev.querySelectorAll('.jdgm-rev__pics img');
        var picsHTML = '';
        pics.forEach(function (img) {
          var src = img.getAttribute('data-src') || img.getAttribute('src');
          if (src) picsHTML += '<img src="' + src + '" alt="Customer review photo" class="zingy-review-pic-' + sectionId + '">';
        });

        html += '<article class="zingy-review-card-' + sectionId + '">' +
          '<div class="zingy-review-head-' + sectionId + '">' +
          '<div class="zingy-review-avatar-' + sectionId + '">' + escapeHtml(author.charAt(0).toUpperCase()) + '</div>' +
          '<div class="zingy-review-meta-' + sectionId + '">' +
          '<p class="zingy-review-name-' + sectionId + '">' + escapeHtml(author) +
          (verified ? '<span class="zingy-review-verified-' + sectionId + '">\u2713 Verified' + (location ? ' ' + escapeHtml(location) : '') + '</span>' : (location ? '<span class="zingy-review-location-' + sectionId + '">' + escapeHtml(location) + '</span>' : '')) +
          '</p>' +
          '<div class="zingy-review-stars-' + sectionId + '">' + starsHTML(sectionId, rating, 14) + '</div>' +
          '</div>' +
          '<span class="zingy-review-date-' + sectionId + '">' + dateText + '</span>' +
          '</div>' +
          (title ? '<h3 class="zingy-review-title-' + sectionId + '">' + escapeHtml(title) + '</h3>' : '') +
          (body ? '<p class="zingy-review-body-' + sectionId + '">' + escapeHtml(body) + '</p>' : '') +
          (picsHTML ? '<div class="zingy-review-pics-' + sectionId + '">' + picsHTML + '</div>' : '') +
          '</article>';
      });
      listEl.innerHTML = html || '<p>No reviews yet.</p>';
    }

    function renderPagination(doc, activePage) {
      var lastPageEl = doc.querySelector('.jdgm-paginate__last-page');
      var pageEls = doc.querySelectorAll('.jdgm-paginate__page[data-page]');
      var maxPage = 1;
      pageEls.forEach(function (p) {
        var n = parseInt(p.getAttribute('data-page'), 10);
        if (n > maxPage) maxPage = n;
      });
      if (lastPageEl) {
        var lp = parseInt(lastPageEl.getAttribute('data-page'), 10);
        if (lp > maxPage) maxPage = lp;
      }
      if (maxPage <= 1) {
        paginationEl.innerHTML = '';
        return;
      }
      var html = '';
      for (var i = 1; i <= maxPage; i++) {
        html += '<button type="button" class="zingy-page-btn-' + sectionId + (i === activePage ? ' zingy-page-btn--active-' + sectionId : '') + '" data-page="' + i + '">' + i + '</button>';
      }
      paginationEl.innerHTML = html;
      paginationEl.querySelectorAll('[data-page]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          fetchReviews(parseInt(btn.getAttribute('data-page'), 10));
        });
      });
    }

    function fetchReviews(page) {
      var endpoint = 'https://api.judge.me/api/v1/widgets/product_review?shop_domain=' +
        encodeURIComponent(SHOP_DOMAIN) + '&api_token=' + encodeURIComponent(JM_TOKEN) +
        '&handle=' + encodeURIComponent(productHandle) + '&page=' + page + '&per_page=' + PER_PAGE +
        '&sort_by=rating&sort_dir=desc';
      fetch(endpoint)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data.widget || '', 'text/html');
          renderSummary(doc);
          renderReviews(doc);
          renderPagination(doc, page);
        })
        .catch(function () {
          root.style.display = 'none';
        });
    }

    fetchReviews(1);
  }

  function initRecentlyViewed(root) {
    var sectionId = root.getAttribute('data-section-id');
    var currentHandle = root.getAttribute('data-product-handle');
    var grid = document.getElementById('zingy-recently-grid-' + sectionId);
    if (!grid) return;

    try {
      var RV_KEY = 'zingy_recently_viewed';
      var stored = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      stored = stored.filter(function (h) { return h !== currentHandle; });
      var toShow = stored.slice(0, 4);

      var updated = [currentHandle].concat(stored);
      updated = updated.filter(function (h, i) { return updated.indexOf(h) === i; }).slice(0, 8);
      localStorage.setItem(RV_KEY, JSON.stringify(updated));

      if (toShow.length === 0) return;

      toShow.forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var price = (p.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
            var card = document.createElement('a');
            card.href = '/products/' + p.handle;
            card.className = 'zingy-recently-card-' + sectionId;
            card.innerHTML =
              '<div class="zingy-recently-img-' + sectionId + '"><img src="' + img + '&width=400" alt="' + escapeHtml(p.title) + '" loading="lazy"></div>' +
              '<div class="zingy-recently-info-' + sectionId + '">' +
              '<p class="zingy-recently-title-' + sectionId + '">' + escapeHtml(p.title) + '</p>' +
              '<p class="zingy-recently-price-' + sectionId + '">' + price + '</p>' +
              '</div>';
            grid.appendChild(card);
            root.style.display = '';
          })
          .catch(function () {});
      });
    } catch (e) {}
  }

  document.querySelectorAll('[data-zingy-reviews]').forEach(initReviews);
  document.querySelectorAll('[data-zingy-recently]').forEach(initRecentlyViewed);
})();
